import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import IP_URL from '../Components/connect';
import { useNavigate, useParams } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Sidebar from '../Components/Sidebar';
import { useSelector } from 'react-redux';
import { selectUser } from '../Redux/currentUserSlice';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Main = styled.div`
  background: #f4f8fb;
  min-height: 100vh;
`;

const Content = styled.div`
  padding: 20px;
`;

const Section = styled.div`
  background: linear-gradient(90deg, #00bcd4, #4180fd);
  color: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  margin-bottom: 25px;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 1.1rem;
  flex: 1;
`;

const Alert = styled.div`
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #4caf50;
  color: white;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  display: ${({ show }) => (show ? 'block' : 'none')};
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  z-index: 1000;
`;

const AddBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 20px;
  padding: 10px 15px;
  color: white;
  font-weight: bold;
  background-color: #31f16e;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
  transition: 0.2s all;

  &:hover {
    background-color: #0b8e0f;
    transform: translateY(-2px);
  }
`;

const Container = styled.div`
  width: 100%;
  overflow-x: auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
`;

const Table = styled.table`
  border-collapse: collapse;
  background-color: #fdfdfd;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  width: 100%;

  th, td {
    padding: 12px 15px;
    border: 1px solid #e0e0e0;
    text-align: center;
    white-space: nowrap;
  }

  th {
    background-color: #1976d2;
    color: white;
    font-weight: bold;
  }

  tbody tr {
    transition: background 0.2s ease;
  }

  tbody tr:nth-child(odd) {
    background-color: #cce5f8ff;
  }

  tbody tr:hover {
    background-color: #e3f2fd;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    th, td {
      padding: 6px 8px;
    }
  }
`;

const SearchInput = styled.input`
  width: 95%;
  padding: 5px 10px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #35c0f3;
  margin: auto;
`;

const DeleteBtn = styled.button`
  color: white;
  background-color: #f45f5f;
  border: none;
  border-radius: 6px;
  padding: 6px 10px;
  cursor: pointer;
  transition: 0.2s all;

  &:hover {
    background-color: #d60000;
    transform: scale(1.05);
  }
`;


const ConfirmModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: ${({ show }) => (show ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  z-index: 2000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  text-align: center;
  width: 90%;
  max-width: 350px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);

  p {
    margin-bottom: 1rem;
    color: #333;
  }

  button {
    margin: 0 8px;
    padding: 6px 14px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
  }

  .cancel {
    background: #95a5a6;
    color: white;
  }

  .confirm {
    background: #e74c3c;
    color: white;
  }
`;

const OrganizationDetails = () => {
  const { uniqueKey } = useParams();
  const [orgData, setOrgData] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const {token} = useSelector( selectUser );
  const [sidebarOpen, setSidebarOpen] = useState(false);
   const [deleteId, setDeleteId] = useState('');

  const toggleSidebar = () => setSidebarOpen(prev => !prev);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(`${IP_URL}/organization/${uniqueKey}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
      if (!response.ok) throw new Error('Failed to fetch organization details');
      const data = await response.json();
      setOrgData(data);
    
    } catch (error) {
      toast.error('Error fetching organization details');
      
    } finally {
      setLoading(false);
    }
  };

  //navigate
  const navigateToMeterDetails = (meterId) => navigate(`/admin-meter-details/${meterId}`);

  //Delete Meter
  const deleteMeter = async () => {
      if (!deleteId) return;
   
      console.log("dletete id:", deleteId)
    
      try {
        const response = await fetch(`${IP_URL}/organization/${uniqueKey}/delete-meter/${deleteId}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
        if (!response.ok) {throw new Error('Failed to delete meter')} 
        else { toast.success(`Meter ${deleteId} deleted successfully`)}
          ;
        fetchData();
      } catch (error) {
        toast.error('Error deleting meter');
      }
    }
  

  const filteredData = orgData.meters
    ? orgData.meters.filter((meter) => meter)
    : [];

  return (
    <Main>
      <Navbar showMenuButton toggleSidebar={toggleSidebar} />
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />


      <Content>
        <Section>
          <Title>Organization: {orgData.userName}</Title>
          <Title>Phone: {orgData.phoneNumber}</Title>
          <Title>Meter Count: {orgData.meters?.length || 0}</Title>
        </Section>

        <AddBtn onClick={() => navigate(`/add-meter/${uniqueKey}`)}>
          <AddIcon /> Add Meter
        </AddBtn>

        <Container>
          <Table>
            <thead>
              <tr>
                <th>
                  <SearchInput
                    type="text"
                    placeholder="Search Meter ID"
                  />
                </th>
                <th>
                  <SearchInput
                    type="text"
                    placeholder="Search Meter Name"
                  />
                </th>
                <th>
                  <SearchInput
                    type="text"
                    placeholder="Search Serial Number"
                  />
                </th>
                <th>Action</th>
              </tr>
              <tr>
                <th>Meter ID</th>
                <th>Meter Name</th>
                <th>Serial Number</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length ? (
                filteredData.map((meter, idx) => (
                  <tr key={idx} onClick={() => navigateToMeterDetails(meter.meterId)}>
                    <td>{meter.meterId}</td>
                    <td>{meter.meterName}</td>
                    <td>{meter.serialNumber}</td>
                    <td>
                      <DeleteBtn onClick={(e) =>
                      { e.stopPropagation();
                        setDeleteId(meter.meterId)}}>
                        <DeleteOutlineIcon />
                      </DeleteBtn>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No meters available</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Container>
      </Content>
      <Footer />
         {/* Delete Confirmation Modal */}
      <ConfirmModal show={!!deleteId}>
        <ModalContent>
          <p>Are you sure you want to delete this meter?</p>
          <button className="cancel" onClick={() => setDeleteId(null)}>
            Cancel
          </button>
          <button className="confirm" onClick={deleteMeter}>
            Delete
          </button>
        </ModalContent>
      </ConfirmModal>
    </Main>
  );
};

export default OrganizationDetails;
